<script>
    // File edit, narrowed to the portal uploads where the Drive folder and the
    // vision model disagreed on the asset type. No global search here: its
    // Search button navigates to /file-edit and drops the narrowing.
    import LeftPanel from '@/components/container/LeftPanel.vue';
    import RightContainer from '@/components/container/RightContainer.vue';
    import MainConainer from '@/components/container/MainContainer.vue';

    import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';
    import ButtonSaveAll from '@/components/left-panel/file-button/ButtonSaveAll.vue';

    import ImageList from '@/components/page-file-edit/images/ImageList.vue';
    import DisputeBulkBar from '@/components/page-file-edit/images/DisputeBulkBar.vue';

    import { promiseAll, calculatePromise } from '@/api/default.js';
    import { DISPUTES_PAGE_SIZE } from '@/api/file.js';

    export default {
        data() {
            let helpOpen = false;
            try { helpOpen = localStorage.getItem('gup-help-open') === '1'; } catch { /* private mode */ }
            return { helpOpen };
        },
        computed: {
            DISPUTES_PAGE_SIZE: () => DISPUTES_PAGE_SIZE,
            imageCount() { return this.$store.getters.IMAGE_COUNT },
            isLoad() { return this.$store.getters.IS_LOAD },
        },
        components: {
            LeftPanel: LeftPanel,
            RightContainer: RightContainer,
            MainConainer: MainConainer,
            ButtonReturn: ButtonReturn,
            ButtonSaveAll: ButtonSaveAll,
            ImageList: ImageList,
            DisputeBulkBar: DisputeBulkBar,
        },
        watch: {
            // The provider / game filter (869fg1k50) lives in the URL.
            async '$route.query.providerID'() { await this.reload(); },
            async '$route.query.gameID'() { await this.reload(); },
        },
        async mounted() {
            this.$store.commit('IS_LOAD', true);
            await this.$store.dispatch('CHECK_ASSET_TYPES');
            await this.setParams();

            const promiseList = await calculatePromise([
                {dispatch: 'CHECK_FILTERS_AXIOS', commit: 'FILTERS_ADD', isArray: true},
                {dispatch: 'CHECK_TAGS_AXIOS', commit: 'TAGS', isArray: false},
                {dispatch: 'CHECK_PROMPTS_AXIOS', commit: 'PROMPTS', isArray: false}
            ]);
            await promiseAll(promiseList);

            await this.$store.dispatch('UPDATE_FILES');
            this.$store.commit('IS_LOAD', false);
        },
        methods: {
            setParams() {
                return this.$store.dispatch('SET_PARAMS_IN_QUERY', {
                    ...this.$route.query,
                    assetTypeID: this.$store.getters.ASSET_TYPE_IMAGES,
                    fileStatus: 'active',
                    disputed: true,
                });
            },
            async reload() {
                this.$store.commit('CLEAR_SELECTED');
                this.$store.commit('IS_LOAD', true);
                await this.setParams();
                await this.$store.dispatch('UPDATE_FILES');
                this.$store.commit('IS_LOAD', false);
            },
            toggleHelp() {
                this.helpOpen = !this.helpOpen;
                try { localStorage.setItem('gup-help-open', this.helpOpen ? '1' : '0'); } catch { /* private mode */ }
            },
        },
    }
</script>


<template>
    <MainConainer>
        <LeftPanel>
            <ButtonSaveAll />
            <hr class="left-separator">
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <div class="gup_header">
                <h2>GUP uploads: папка и модель разошлись в типе</h2>
                <p>Файлы залиты через портал; тип поставила папка на Диске, модель хотела другой. Решённый файл уходит из списка.</p>
                <button class="help_toggle" title="Короткая инструкция: как разбирать спорные строки." @click="toggleHelp">
                    Как разбирать спорные <span>{{ helpOpen ? '▲' : '▼' }}</span>
                </button>
                <div v-if="helpOpen" class="help">
                    <div><b>1. Что такое спор.</b> Папка на Диске поставила файлу один тип, vision-модель предложила другой. Кто прав, решаешь ты.</div>
                    <div><b>2. Смотри превью.</b> Клик по картинке открывает оригинал.</div>
                    <div><b>3. Одна строка, три решения:</b> <span class="kbd">Папка права</span>, <span class="kbd">Модель права</span> или <span class="kbd red">Удалить</span>. <span class="kbd">Все свойства</span> раскрывает полную карточку: фильтры, теги, HQ, статус.</div>
                    <div><b>4. Много строк сразу.</b> Выбери провайдера и игру в строке "Показать", чтобы в списке остались только их спорные. Отметь строки галочками или нажми <span class="kbd">Все на странице</span> (повторный клик снимает отметки), потом одно действие в панели над списком. Действие касается только отмеченных строк на экране.</div>
                    <div><b>5. Неправы и папка, и модель.</b> В панели нажми на поле "Свой тип", выбери тип из списка (можно начать печатать название) и нажми <span class="kbd">Применить</span>. Всем отмеченным строкам встанет этот тип.</div>
                    <div><b>6. Удаление необратимо.</b> Файл уходит из каталога и из хранилища S3, портал больше не загрузит его повторно.</div>
                    <div><b>7. Решённые строки уходят из списка</b> сразу после действия, счётчик "Спорных" сверху уменьшается, следующие строки подгружаются сами.</div>
                    <div><b>8. Если строк больше 50</b>, остальные на следующих страницах, переключатель внизу списка. Панель с действиями прилипает к верху экрана при прокрутке.</div>
                </div>
            </div>
            <DisputeBulkBar />
            <ImageList :per-page="DISPUTES_PAGE_SIZE" :server-paged="true" :header-label="(n) => `Спорных: ${n}`" />
            <p class="gup_header" v-if="isLoad === false && imageCount === 0">{{ $route.query.gameID || $route.query.providerID ? 'По этому фильтру спорных нет.' : 'Спорных нет.' }}</p>
        </RightContainer>
    </MainConainer>
</template>


<style scoped>
    .gup_header {
        padding: 0 12px 12px;
    }
    .help_toggle {
        margin-top: 6px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font: inherit;
        font-weight: bold;
        color: var(--main-color);
        background: var(--background-color);
        border: 1px solid var(--main-color);
        border-radius: 5px;
        padding: 9px 14px;
        cursor: pointer;
    }
    .help_toggle span { font-size: 11px; }
    .help_toggle:hover { background: var(--background-hover); }
    .help {
        margin-top: 12px;
        max-width: 980px;
        background: var(--background-color);
        color: var(--text-color);
        border: 1px solid var(--border-color);
        border-left: 4px solid var(--main-color);
        border-radius: 5px;
        padding: 20px 24px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        line-height: 1.55;
        font-size: 14px;
    }
    .kbd {
        display: inline-block;
        background: var(--main-color);
        color: #ffffff;
        font-weight: bold;
        font-size: 12px;
        border-radius: 5px;
        padding: 3px 8px;
    }
    .kbd.red { background: #fc424a; }
</style>
